'use strict'

export default function getProjectDefinition(project) {
  return {
    background: {
      initiated: project.background,
      timing: project.timing,
      bigPicture: project.bigPicture
    },
    objective: {
      benefits: project.benefitsDescription,
      summary: project.objectivesSummary,
      comments: project.objectives
    },
    scope: {
      items: project.projectScope,
      exclusions: project.scopeExclusions
    },
    outcomes: project.outcomes,
    constraints: project.constraints,
    assumptions: project.assumptions,
    stakeholders: project.stakeholderDescription,
    interfaces: project.interfaces
  };
}



// WEBPACK FOOTER //
// ./app/model/getProjectDefinition.js